import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
// import QuotationPDF from "./QuotationPDF"; 
import QuotationForm from './QuotationForm';
import QuotationPDF1 from "./QuotationPDF1"; 

const QuotationDetails = () => {
  const { id } = useParams(); // Get quotation ID from URL
  const [quotation, setQuotation] = useState(null); // State to hold the quotation data
  const navigate = useNavigate();
  const [quotationTerms, setQuotationTerms] = useState("");
  const [companyDetails, setCompanyDetails] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [products, setProducts] = useState(null);
  const [projects, setProjects] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [errors, setErrors] = useState({});
  const [quotationNotes, setQuotationNotes] = useState("");
  const fetchCompanyDetails = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const userInfo = JSON.parse(localStorage.getItem("user-info"));
      const origin = localStorage.getItem("user-origin");
      const token = userInfo?.token;

      const response = await axios.get(`${backendUrl}/api/settings`, {
        headers: { Authorization: `Bearer ${token}`,  "Tenant-Origin": origin },
      });

      setCompanyDetails(response.data.setting);
    } catch (error) {
      console.error("Error fetching company details:", error);
    }
  };
  // Fetch quotation data from API
  const fetchQuotationById = async (quotationId) => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL; // Backend base URL
      const userInfo = JSON.parse(localStorage.getItem("user-info"));
      const origin = localStorage.getItem('user-origin');
      // Retrieve user info from localStorage
      const token = userInfo?.token; // Extract token

      const response = await axios.get(
        `${backendUrl}/api/quotations/${quotationId}`,
        {
          headers: { Authorization: `Bearer ${token}` ,                'Tenant-Origin': origin,
        },
        }
      );
      console.log("API Response:", response.data);

      return response.data.quotation; 
      // Return the quotation data
    } catch (error) {
      console.error(`Error fetching quotation with ID ${quotationId}:`, error);
      return null; // Return null if error occurs
    }
  };
 

  const fetchProducts = async () => {
    try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;

        let allProducts = [];
      

 
            const response = await axios.get(`${backendUrl}/api/products`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const  data  = response.data.Data;

            // allProducts = [...allProducts, ...data]; // Append new products to the list
           

        setProducts(data);
    } catch (error) {
        console.error('Error fetching products:', error);
    }
};
const fetchProjects = async () => {
  try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');
      const token = userInfo?.token;

      // Build the URL with query parameters
      let url = `${backendUrl}/api/projects?all=true`;

      // If all is true, add the all=true parameter to the URL
      // if (all) {
      //     url += `&all=true`;
      // }

      const response = await axios.get(url, {
          headers: { 'Authorization': `Bearer ${token}`,
          'Tenant-Origin': origin },
      });

      const projectData = response.data.Data || [];
      setProjects(projectData);

      const totalPages = response.data.Data?.meta?.total_pages || 1;
      setPageCount(totalPages);
  } catch (error) {
      console.error('Error fetching projects:', error);
  }
};



const editQuotation = async (quotationId, updatedData) => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem("user-origin");
    const token = userInfo?.token;

    const response = await axios.post(
      `${backendUrl}/api/quotations/${quotationId}?_method=PUT`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "Tenant-Origin": origin,
        },
      }
    );

    const updatedQuotation = response.data.quotation;

    if (updatedQuotation) {
      // Merge existing state with updated data
      setQuotation((prev) => ({
        ...prev,
        ...updatedQuotation,
        project: prev?.project || updatedQuotation.project, // Preserve project details
        project: {
          ...prev?.project,
          ...updatedQuotation.project,
          client: {
            ...prev?.project?.client,
            ...updatedQuotation.project?.client,
          },
        },
      }));
    } else {
      console.error("Update failed, no data returned.");
    }

    closeEditModal();
  } catch (error) {
    if (error.response?.data?.errors) {
      return error.response.data.errors; // Return validation errors
    } else {
      console.error("Error updating quotation:", error);
    }
  }
};


// useEffect(() => {
//   // Fetch projects when the component is mounted or the quotation id changes
//   fetchProjects();
// }, [id]); // You can add other dependencies if needed

  useEffect(() => {
    const loadQuotation = async () => {
      const fetchedQuotation = await fetchQuotationById(id);
      if (fetchedQuotation) {
        setQuotation(fetchedQuotation);
        setQuotationNotes(fetchedQuotation.notes); 
        // await fetchQuotationTerms(fetchedQuotation.currency);
      }
    };
    fetchCompanyDetails();
    loadQuotation();
  }, [id]);

  const handleEditClick = () => {
    const projectId=quotation.project_id;
    
    if (quotation && projectId) {
        console.log("quou:",projectId)
        setIsEditModalOpen(true); // Open the modal only if purchaseorder data and quotation_id are available
    } else {
        console.error("Quotation ID is missing.");
    }
};


const closeEditModal = () => {
    setIsEditModalOpen(false); // Close the modal
};
  const handleBackClick = () => {
    navigate(-1);
  };
  // Show loading message while fetching data
  if (!quotation) return <div>Loading...</div>;
  const hasDiscount = quotation.discount_amount && quotation.discount_amount > 0;

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Quotation Details</h4>
                <div className="page-title-right">

                  <div className="page-title-right d-flex align-items-center">
                  <button style={{
                                            padding: "6px 16px",
                                            backgroundColor: "#415094",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "14px",}}
                                             className="btn btn-warning" onClick={handleEditClick}>
                                        Edit
                                    </button>&nbsp;&nbsp;
                    {/* <PDFDownloadLink
                      document={<QuotationPDF1 quotation={quotation}  quotationNotes={quotationNotes} quotationTerms={quotationTerms} companyDetails={companyDetails} />}
                      fileName={`${quotation.ref_no}.pdf`}
                    >
                      {({ loading }) => (
                        <button
                          style={{
                            padding: "6px 16px",
                            backgroundColor: "#415094",
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        >
                          {loading ? " " : "Download"}
                        </button>
                      )}
                    </PDFDownloadLink> */}


<button
  style={{
    padding: "6px 16px",
    backgroundColor: "#415094",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
  }}
  onClick={() => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem("user-origin");
    const token = userInfo?.token;

    // Create download link
    const downloadUrl = `${backendUrl}/api/quotations/${id}/download`;
    
    // Create temporary anchor element for download
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', `${quotation.ref_no}.pdf`);
    document.body.appendChild(link);
    
    // Add authorization headers through fetch
    fetch(downloadUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Tenant-Origin': origin,
      }
    })
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    })
    .catch(error => console.error('Download failed:', error));
  }}
>
  Download
</button>
                    
                    &nbsp;&nbsp;
                    <button style={{
                      padding: "6px 16px",
                      backgroundColor: "#415094",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                      onClick={handleBackClick} className="btn btn-secondary  back">Back</button>
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div> </div>


          {/* A4 Quotation Layout */}
          <div style={styles.page}>
            {/* Header Section */}
            <div style={styles.header}>
              <div>
                <h2 style={styles.companyName}>{companyDetails?.company_name||'Systech Technologies'}</h2>
                <p style={styles.companyDetails}>
                {companyDetails?.phone} <br />
                {companyDetails?.email}<br />
                <p dangerouslySetInnerHTML={{ __html: companyDetails?.company_address }} />
                </p>
              </div>
              <div style={styles.topRight}>
                <img
                  src="/images/655c8bbb23be8.png" // Provide the image source
                  alt="Company Logo"
                  style={styles.image}
                />



                <div style={styles.quotationTitle}>Quotation</div>
              </div>
            </div><hr style={styles.hr} />

            {/* Quotation Details */}
            <div style={styles.detailsSection}>
              <div>
              <p style={{ display: "flex", marginBottom: "13px" }}>
              <strong style={{ width: "90px" }}>Project:</strong>
                  <span>{quotation.project?.name || " "}</span>
                </p>
                <p style={{ display: "flex", marginBottom: "13px" }}>
                  <strong style={{ width: "90px" }}>Document No:</strong>
                  <span>{quotation?.ref_no || ""}</span>
                </p>
                <p style={{ display: "flex", marginBottom: "13px" }}>
                <strong style={{ width: "90px" }}>Date:</strong>
                  <span>{quotation.date || ""}</span>
                </p>
              </div>
              <div>
                <p>
                  <strong>Customer:&nbsp;</strong>{quotation.project?.client?.name || " "}
                </p>
                <p>
                  <strong>Address:&nbsp;</strong>{quotation.project?.client?.address || " "}
                </p>
                <p>
                  <strong>Contact Phone:&nbsp;</strong>{quotation.project?.client?.contacts[0]?.phone || ""}
                </p>
                <p>
                  <strong>Contact Email:&nbsp;</strong> {quotation.project?.client?.contacts[0]?.email || ""}
                </p>
              </div>
            </div><br /><br />

            {/* Table Section */}
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>No</th>
                  <th style={styles.tableHeader}>Product</th>
                  <th style={styles.tableHeader}>Description</th>
                  <th style={styles.tableHeader}>QTY</th>

                  <th style={styles.tableHeader}>Rate</th>
                  <th style={styles.tableHeader}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {quotation.product_item_details && quotation.product_item_details.length > 0 ? (
                  quotation.product_item_details.map((item, index) => (
                    <tr key={index}>
                      <td style={styles.tableCell}>{index + 1}</td>
                      <td style={styles.tableCell}>{item.item_name || " "}</td>
                      <td style={styles.tableCell}>
                        {item.item_description || ""}
                      </td>
                      <td style={styles.tableCell}>{item.quantity || ""}</td>
                      <td style={styles.tableCell}>{item.price || ""}</td>

                      <td style={styles.tableCell}>{item.subtotal || ""}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      No items available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Footer Section */}
            <div style={styles.footer}>
              
               <p>
                <strong>Total License Cost Per Month:</strong> {quotation.subscription_amount || ''}
              </p>
               <p>
                <strong>Total License Cost Per {quotation.subscription_period || 12 } Month:</strong> {quotation.total_amount_with_subscription || ""}
              </p>
               <p>
                <strong>One-Time/Deployment Cost :</strong> {quotation.deplyment_amount || ""}
              </p>
              {hasDiscount && (
                <div>
                  <p>
                    <strong> One Time Discount{quotation.discount_type === 'percentage' ? ' (%)' : ''}:</strong>&nbsp; {quotation.discount_amount || ""}
                  </p>
                </div>
              )}
              <p>
                <strong>Total Amount ({quotation.currency || "USD"}):</strong> {quotation.amount || ""}
              </p><br/><br/><br/>
              {/* {quotationTerms && (
                <div style={styles.terms}>
                  <div dangerouslySetInnerHTML={{ __html: quotationTerms }} />


                </div>
              )} */}
               <div style={styles.terms}>
    {quotation.notes && (
      <div>
        <div dangerouslySetInnerHTML={{ __html: quotation.notes }} />
      </div>
    )}
  </div>
            </div>
            <div style={styles.signfooter}>
              <div style={styles.signatureSection}>
                {["Customer", "Stamp", "Authorized"].map((role, index) => (
                  <div key={index} style={styles.signatureBlock}>
                    <p>--------------------------</p> {/* Placeholder line */}
                    <p style={{ marginBottom: 0, lineHeight: "14px" }}>{role}</p>
                    <p>{role === "Stamp" ? "" : "Signature"}</p>
                  </div>
                ))}
              </div>
            </div>
            {quotation ? (
    isEditModalOpen && (
      <QuotationForm
      showModal={isEditModalOpen}
      handleClose={closeEditModal}
      quotationData={quotation || {}}  // Ensure it's not null
      quotationId={id}
      products={products || []} // Ensure it's not null or undefined
      // fetchProducts={fetchProducts}
      setProducts={setProducts}
      editQuotation={editQuotation}
      projects={projects || []}
      errors={errors}
      setErrors={setErrors}
      fetchProjects={fetchProjects}
      projectName={quotation.project?.name || ""}
      clientName={quotation.project?.client?.name || ""}
      clientCurrency={quotation.project?.client?.currency || ""}
      projectId={quotation.project_id}
       // Ensure it's not null or undefined
  />
    )
) : (
    <div>Loading...</div> // Show loading while fetching data
)}
          </div>
        </div>
      </div>
    </div>
  );
};


export default QuotationDetails;

// Inline Styles for A4 Layout
const styles = {
  page: {
    width: "210mm",
    minHeight: "200mm",
    margin: "0 auto",
    padding: "10mm",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#ffffff",
    border: "1px solid #ddd",
    fontSize: "12px",
    borderRadius: "12px"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    // marginBottom: "20px",
  },
  companyName: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#415094",
  },

  companyDetails: {
    fontSize: "14px",
    // marginTop: "5px",
    color: "#415094",
    marginTop:"-7px"


  },

  quotationTitle: {
    fontSize: "24px",
    color: "#415094",
    // marginBottom: "30px",

    // marginLeft: "10px",
    lineHeight: ".4",
    // Add some margin between the image and the title
  },
  headerRight: {
    display: "flex",  // Make the container a flexbox to align the image and title side by side
    alignItems: "center", // Vertically align the content in the center
  },
  topRight: {
    alignSelf: "start",
    textAlign: "right",
  },
  Right: {
    alignSelf: "start",
    textAlign: "right",
    // marginTop: "20px",
  },
  image: {

    objectFit: "contain",
    marginBottom: "12px",
    maxWidth: "214px",
    maxHeight: "100px",


  },
  hr:{
    marginTop: "-7px"
  },
  detailsSection: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
    // marginTop: "10px",
    lineHeight: ".7",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "10px",
    lineHeight: "3",

  },
  tableHeader: {
    borderBottom: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
    fontWeight: "bold",
  },
  tableCell: {
    borderBottom: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  },
  footer: {
    marginTop: "20px",
    textAlign: "right",
  },
  terms: {
    fontSize: "12px",
    marginTop: "10px",
    textAlign: "left",
  },
  signfooter: {
    marginTop: "150px",
    textAlign: "center",

  },
  signatureSection: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    marginTop: "20px",
  },
  signatureBlock: {
    textAlign: "center",
  },
  signatureImage: {
    width: "120px",
    height: "50px",
    objectFit: "contain",
    marginBottom: "10px",
  },
};
